import {useTranslation} from 'react-i18next'
import Button from 'features/common/components/Button'
import EmployeeModal from '../common/EmployeeModal'
import useDeleteEmployee from '../../../../../common/hooks/useDeleteEmployee'

interface StaffModalProps {
    employee: {
        id: number
        name: string
        role: string
        photo: string
        qrId: number
    }
    onClose: () => void
}

const DeleteModal = ({employee, onClose}: StaffModalProps) => {
    const {t} = useTranslation()
    const {mutate: deleteEmployee} = useDeleteEmployee({onSuccess: onClose})
    const isOpen = !!employee

    return (
        <EmployeeModal isOpen={isOpen} onClose={onClose}>
            <div className="flex w-[42rem] flex-col items-center">
                <div className="mb-12 text-5xl font-medium text-yellow-40">
                    {t('QR_REMOVE_EMPLOYEE')}
                </div>
                <img
                    className="mb-4 h-52 w-52 rounded-full"
                    src={employee.photo}
                    alt="avatar"
                />
                <div className="mb-2 text-2xl font-medium">{employee.name}</div>
                <div className="mb-16 font-medium text-grey-70">
                    {employee.role}
                </div>
                <div className="grid grid-cols-2 gap-10">
                    <Button
                        onClick={() =>
                            deleteEmployee({
                                employeeId: employee.id,
                                qrId: employee.qrId,
                            })
                        }
                        className="w-52 rounded-full bg-red-10 py-4"
                    >
                        {t('QR_BUTTON_REMOVE')}
                    </Button>
                    <Button
                        onClick={onClose}
                        className="w-52 rounded-full py-4"
                    >
                        {t('QR_BUTTON_CANCEL')}
                    </Button>
                </div>
            </div>
        </EmployeeModal>
    )
}

export default DeleteModal
